import { Box, Grid } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FormEvent, useEffect, useState } from 'react';
import PhoneInput2 from 'react-phone-input-2';

interface IPhoneInputProps {
    defaultPhoneNumber?: string;
    defaultCountryCode?: string;
    countryCode?: string;
    phoneNumber?: string;
    onChange?: (countryCode: string, phoneNumber: string) => void;
    disabled?: boolean;
    onEnterKeyPress?: (event: FormEvent) => void;
    error?: boolean;
    controlled?: boolean;
}

const PhoneInput = ({
    defaultCountryCode = '389',
    defaultPhoneNumber = '',
    countryCode: _countryCode,
    phoneNumber: _phoneNumber,
    onChange,
    disabled = false,
    onEnterKeyPress,
    error = false,
    controlled,
}: IPhoneInputProps) => {
    const [countryCode, setCountryCode] = useState<string>(defaultCountryCode || '389');
    const [phoneNumber, setPhoneNumber] = useState<string>(defaultPhoneNumber);

    const { t } = useTranslation('common');

    useEffect(() => {
        if (onChange) {
            onChange(`${countryCode}`, `${phoneNumber}`);
        }
    }, [countryCode, phoneNumber]);

    return (
        <Box mt={2}>
            <Grid container direction="row" justifyContent="center">
                <Grid item style={{ width: '100px' }}>
                    <PhoneInput2
                        value={controlled ? _countryCode : countryCode}
                        onChange={cc => setCountryCode(cc)}
                        inputStyle={{
                            height: 'unset',
                            outline: 'none',
                            width: '101px',
                            borderRadius: '5px 0 0 5px',
                        }}
                        containerStyle={{ width: 'auto' }}
                        buttonStyle={{
                            backgroundColor: 'white',
                            borderRightStyle: 'none',
                        }}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item style={{ flex: 1 }}>
                    <PhoneInput2
                        value={controlled ? _phoneNumber : phoneNumber}
                        onChange={phone => setPhoneNumber(phone)}
                        placeholder={t('phone')}
                        inputStyle={{
                            height: 'unset',
                            paddingLeft: '12px',
                            borderRadius: '0 5px 5px 0',
                            width: '100%',
                            flex: 1,
                        }}
                        containerStyle={{ width: 'auto', flex: 1 }}
                        disableCountryCode={true}
                        disableCountryGuess={true}
                        // disableDropdown={true}
                        buttonStyle={{ display: 'none' }}
                        disabled={disabled}
                        onEnterKeyPress={onEnterKeyPress}
                        isValid={(value, country) => {
                            return !error;
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default PhoneInput;
